import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import StandardDialog from '../components/Complements/StandardDialog';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import { isMobile, osName, osVersion } from 'react-device-detect';
import MessageInfo from '../components/Complements/MessageInfo';
import TaxeRenderBody from '../components/Taxes/TaxeRenderBody';
import TaxePanel from '../components/Taxes/TaxePanel';
import DialogOTP from '../components/Complements/DialogOTP';
import { FormControl, Grid, Icon, InputLabel, ListItemText, MenuItem, Select, List, ListItem, ListItemAvatar, Avatar, Typography, Button } from '@material-ui/core';
import { feathersCreateData } from '../services';
import { history } from '../helpers/history';
import { processPaymentCertificate } from '../services/coreProcess';
import { validateIp } from '../functions/store';
import ActivityButtons from '../components/Certificates/ActivityButtons';
import { downloadDevice, handleCancelTransferForm, handleDownloadVoucher, handleSendEmailWithVoucher } from '../components/Certificates/ActivitiesActions';
import { urlValidateCertificates } from '../services/urls';
import { getBalanceUser } from "./../actions/balances";
import { connect } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import { changeStatusUser } from './../actions/codes'
import { encrypt } from './../functions/mobile';

const useStyles = makeStyles(theme => ({

    submit: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderRadius: '0px',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #0073D2',
            backgroundColor: "white",
            //fontFamily: 'Ubuntu',
            "&:hover": {
                backgroundColor: "white"
            }
        },
    }
}));

const CertificatesContainer = props => {
    const { user, balances, handleOpenSnack, auth, parameters, devices, getCertificatesCore, certificates, /* credits, */ deposits } = props
    const [accountSelected, setAccountSelected] = useState(balances[0])
    const [showDialogAccounts, setShowDialogAccounts] = useState(false)
    const [showvoucher, setShowvoucher] = useState(false)
    const [loading, setLoading] = useState(false)
    const [certificateTypeSelected, setCertificateTypeSelected] = useState({})
    const [dialog, setDialog] = useState({ state: false, title: '', content: <div></div> })
    const [show, setShow] = useState(true)
    const [nameFile, setNameFile] = useState('')
    const [OTP, setOTP] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })
    //const [ contAttemptsAcademyProcess, setcontAttemptsAcademyProcess ] = useState(0)

    const classes = useStyles()

    // carga inicial
    const mount = () => {
        const unmount = () => {
            //console.log("data certificados: ", certificates)
            updateBalances()
            if (certificates !== undefined && certificates.length <= 0) {
                getCertificatesCore(filterArrayEqual(parameters, 'code', 'SEQUENTIAL_COMPANY')[0].value)
            }
            setShow(true)
        }
        return unmount()
    }

    useEffect(mount, [auth, handleOpenSnack])

    const updateBalances = async () => {

        setLoading(true)
        await props.getBalanceUser({ NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true })
        setLoading(false)

    }

    const updateBalanceAccountSelected = async () => {

        setLoading(true)
        const response = await props.getBalanceUser({ NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true })
        //console.log(response)

        const { data } = response.payload;

        const responseFilterAccount = data.filter((item) => item.PRODUCTBANKID === accountSelected.PRODUCTBANKID)

        setAccountSelected(responseFilterAccount[0])
        setLoading(false)
    }

    const handleRequestCode = async () => {
        try {

            setLoading(true)
            const { ip } = devices
            const { getDeviceData, updateIpDevice } = props
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            let deviceData = `${osName} ${osVersion}`
            let mac = 'NAVEGADOR'
            if (!isEmpty(devices)) {
                const { device, ip: ipDevice, mac: macDevice } = devices
                deviceData = device;
                ipSend = ipDevice;
                mac = macDevice;
            }

            const sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE', type: 28, deviceData, ip: ipSend, mac
            }))

            feathersCreateData('codes-recovery', { sendData })()
                .then((res) => {
                    // console.log(res)
                    //const { result, data } = res
                    setOTP({
                        ...OTP,
                        type: 'CERTIFICATE_PROCESS',
                        openOtp: true
                    })
                    setLoading(false)
                }).catch(err => {
                    //console.log(err)
                    setLoading(false)
                    handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
                })
        } catch (error) {
            //console.log(error)
            handleOpenSnack('Error al solicitar PRODUCTBANKID.', 'info')
        }

    }

    const handleCertificatesChange = (e) => {

        //console.log("value: ", e.target.value)

        const { codigo } = e.target.value

        if (codigo === "ACT_ACC") {
            setCertificateTypeSelected(e.target.value)
            /*const { infoPayment } = credits;

            if (infoPayment.length === 0) {
                handleOpenSnack("Usted no tiene creditos activos.", "info")
            } else {
                setCertificateTypeSelected(e.target.value)
            }*/
        } else {

            if (codigo === "C_INVER") {

                const { info } = deposits

                if (info.length === 0) {
                    handleOpenSnack("Usted no tiene depósitos a plazo fijo activos.", "info")
                } else {
                    setCertificateTypeSelected(e.target.value)
                }
            } else {
                setCertificateTypeSelected(e.target.value)
            }
        }

    }
    const renderProcess = () => {
        // se renderiza el panel de informacion o el formulario para buscar las academias
        if (show) {
            // render de formulario de busqueda
            return <div>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <FormControl variant="outlined" style={{ minWidth: '100%' }}>
                            <InputLabel id="certificateType">{'Tipo de certificado'}</InputLabel>
                            <Select
                                labelId="certificateType"
                                id="certificateType"
                                label="Tipo de certificado"
                                value={certificateTypeSelected}
                                onChange={handleCertificatesChange}
                                autoComplete='none'
                            >
                                {
                                    certificates.map(row => {
                                        return <MenuItem key={row.codigo} value={row}>{row.nombre}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {
                            !isEmpty(certificateTypeSelected) &&
                            <List>
                                <ListItem key={1} >
                                    <ListItemAvatar>
                                        <Avatar> <Icon>paid</Icon> </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={<Typography > {`Valor: $${certificateTypeSelected.ValorDebito}`}</Typography>} />
                                </ListItem>
                            </List>
                        }
                    </Grid>
                    <Grid item xs={6} md={6}>
                        {
                            !isEmpty(certificateTypeSelected) &&
                            <Button fullWidth variant="contained" onClick={(parseFloat(certificateTypeSelected.ValorDebito) > 0) ? handleRequestCode : handleGenerateCertificate} className={classes.submit}>
                                Generar
                            </Button>
                        }
                    </Grid>
                    <Grid item xs={6} md={6}>
                        {
                            !isEmpty(certificateTypeSelected) &&
                            <Button fullWidth variant="contained" onClick={() => history.push('/')} className={classes.submit}>
                                Cancelar
                            </Button>
                        }
                    </Grid>
                </Grid>
            </div>
        } else {
            return <div>

            </div>
        }
    }
    const handleChangeInputOtp = (valueinput) => {
        if (valueinput.target.value.toString().length === 4) {
            handleOTPCompare({ data: valueinput.target.value.toString() });
        }
    }
    const handleAccountChange = () => {
        setShowDialogAccounts(!showDialogAccounts)
    }

    const cleanDialog = () => {
        setLoading(false)
        setDialog({
            state: false,
            title: '',
            content: <div></div>
        })
    }

    const handleOTPCompare = async ({ data }) => {
        // const { id } = auth
        setLoading(true)
        //const { code } = OTP
        try {

            const { ip, device, mac } = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: 28,
                inputOtp: data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type: typeMessage, viewDialogOtp } = responseValidateCode;

            if (error === false) {
                // proceso de certificado
                // SecuencialEmpresa, SecuencialCuenta, NumeroDeIdentificacion, PRODUCTBANKIDTipoCertificado accountSelected.PRODUCTBANKID

                const sendData = encrypt(JSON.stringify({
                    SecuencialEmpresa: 1,
                    SecuencialCuenta: accountSelected.Secuencial,
                    NumeroCuentaOrigen: accountSelected.PRODUCTBANKID,
                    // accountAmount: accountSelected.SaldoCuenta,
                    //NumeroDeIdentificacion: auth.vusk,
                    //NumeroCliente: user.NumeroCliente,
                    PRODUCTBANKIDTipoCertificado: certificateTypeSelected.PRODUCTBANKID,
                    NombreCertificado: certificateTypeSelected.Nombre,
                    // Names: user.Nombres + ' ' + user.Apellidos,
                    Valor: certificateTypeSelected.ValorDebito,
                    //otpId: OTP.id,
                    urlCertificates: urlValidateCertificates,
                    dataDevice: {
                        ip,
                        mac,
                        device
                    },
                    otp: data
                }))

                processPaymentCertificate({
                    sendData
                }).then(res => {
                    //console.log("CERT-"+certificateTypeSelected.PRODUCTBANKID+"-"+res.data.SecuencialCertificado)
                    //console.log(res)
                    updateBalanceAccountSelected()
                    setNameFile(res.namefile)
                    setLoading(false)
                    setShowvoucher(true)
                    handleOpenSnack(res.message, 'success')
                    setOTP({ ...OTP, openOtp: false })
                }).catch(err => {
                    //console.log(err)
                    handleOpenSnack('No se ha podido generar el certificado.', 'error')
                    setLoading(false)
                    setShowvoucher(false)
                    setOTP({ ...OTP, openOtp: false })
                })
            } else {
                if (viewDialogOtp === false) {
                    setOTP({ ...OTP, openOtp: false })
                }
                setLoading(false)
                handleOpenSnack(message, typeMessage);
            }
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack('No se ha podido realizar la generación del certificado.', 'error')
        }
    }

    const handleGenerateCertificate = () => {

        setLoading(true)

        try {

            const { ip, device, mac } = devices

            const sendData = encrypt(JSON.stringify({
                SecuencialEmpresa: 1,
                SecuencialCuenta: accountSelected.Secuencial,
                NumeroCuentaOrigen: accountSelected.PRODUCTBANKID,
                PRODUCTBANKIDTipoCertificado: certificateTypeSelected.PRODUCTBANKID,
                NombreCertificado: certificateTypeSelected.Nombre,
                Valor: certificateTypeSelected.ValorDebito,
                urlCertificates: urlValidateCertificates,
                dataDevice: {
                    ip,
                    mac,
                    device
                },
                otp: ""
            }))

            processPaymentCertificate({
                sendData
            }).then(res => {
                //console.log("CERT-"+certificateTypeSelected.PRODUCTBANKID+"-"+res.data.SecuencialCertificado)
                // console.log(res)
                updateBalanceAccountSelected()
                setNameFile(res.data.namefile)
                setLoading(false)
                setShowvoucher(true)
                handleOpenSnack(res.message, 'success')
                //setOTP({...OTP, openOtp: false})
            }).catch(err => {
                //console.log(err)
                handleOpenSnack('No se ha podido generar el certificado.', 'error')
                setLoading(false)
                setShowvoucher(false)
                //setOTP({...OTP, openOtp: false})
            })

        } catch (error) {

            setLoading(false)
            handleOpenSnack('No se ha podido realizar la generación del certificado.', 'error')
        }
    }

    const renderBody = () => {
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <UserPanelInfoMobile
                    user={user}
                    balances={balances}
                    accountSelected={accountSelected}
                    changeAccount={setAccountSelected}
                    handleAccountChange={handleAccountChange}
                    dialog={showDialogAccounts}
                >
                    {(showvoucher === false) ? renderProcess() :
                        <Grid container spacing={3} justify="center" alignItems="center">
                            <Grid item xs={12} md={12}>
                                <MessageInfo type='success' text={'Certificado creado satisfactoriamente.'} />
                            </Grid>
                            <Grid item xs={12} md={12}></Grid>
                            <ActivityButtons
                                actionLabels={['Nuevo Certificado', 'Reenviar Certificado', 'Cancelar', 'Descargar Certificado', 'Compartir Certificado']}
                                handleSendEmailWithVoucher={() => handleSendEmailWithVoucher(setLoading, user.CorreoElectronico, handleOpenSnack, nameFile)}
                                handleCancelTransferForm={handleCancelTransferForm}
                                onActionAfter={() => setShowvoucher(false)}
                                handleDownloadVoucher={() => handleDownloadVoucher(nameFile)}
                                handleDownloadDevice={() => downloadDevice(nameFile)}
                            />
                        </Grid>
                    }
                </UserPanelInfoMobile>
            }

        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <TaxeRenderBody
                    user={user}
                    balances={balances}
                    accountSelected={accountSelected}
                    changeAccount={setAccountSelected} >
                    <TaxePanel>
                        {
                            (showvoucher === false) ? renderProcess() :
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12}>
                                        <MessageInfo type='success' text={'Certificado creado satisfactoriamente.'} />
                                    </Grid>
                                    <Grid item xs={12} md={12}></Grid>
                                    <ActivityButtons
                                        actionLabels={['Nuevo Certificado', 'Reenviar Certificado', 'Cancelar', 'Descargar Certificado', 'Compartir Certificado']}
                                        handleSendEmailWithVoucher={() => handleSendEmailWithVoucher(setLoading, user.CorreoElectronico, handleOpenSnack, nameFile)}
                                        handleCancelTransferForm={handleCancelTransferForm}
                                        onActionAfter={() => setShowvoucher(false)}
                                        handleDownloadVoucher={() => handleDownloadVoucher(nameFile)}
                                        handleDownloadDevice={() => downloadDevice(nameFile)}
                                    />
                                </Grid>
                        }
                    </TaxePanel>
                </TaxeRenderBody>
            }

        }
    }

    const timeLifeTokenObj = filterArrayEqual(parameters, 'code', 'TIME_LIFE_TOKEN')
    const timeLifeToken = (timeLifeTokenObj.length > 0) ? Number(timeLifeTokenObj[0].value) : 180000

    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                multiple={false}
            />
            <LoadingScreen open={loading} />
            <StandardDialog
                open={dialog.state}
                title={dialog.title}
                handleClose={() => cleanDialog()} >
                {dialog.content}
            </StandardDialog>
            <DialogOTP
                openDialogOTP={OTP.openOtp}
                onCloseDialogOTP={() => setOTP({ ...OTP, openOtp: false })}
                initialTime={Date.now()}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPCompare}
                onKeyPress={handleChangeInputOtp}
                timeLifeToken={timeLifeToken}
            />
        </div>
    )
};

CertificatesContainer.propTypes = {
    user: PropTypes.object.isRequired,
};

export default connect(null, {
    getBalanceUser,
    changeStatusUser
})(CertificatesContainer)
